var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"announcement-bar",class:_vm.severity,attrs:{"data-color":"announce"}},[_c('a',{attrs:{"href":_vm.link,"target":"_blank"}},[_c('span',{staticClass:"message"},[_vm._v("\n      "+_vm._s(_vm.message)+"\n    ")])]),_vm._v(" "),_c('button',{staticClass:"close icon icon_delete",on:{"click":_vm.onClose}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbc0c5e2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/announcement-bar.vue
// module id = 1495
// module chunks = 0